import React, { useState } from "react";
import { toast } from "sonner";
import { IdCard } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, Input, Label } from "@/components/ui-kit";
import { api, errorText } from "@/lib/api";
import { usePrefs } from "@/contexts/PrefsContext";

export const CustomerDetailsDialog = ({ userId, name, phone, onClose, onDone }: { userId: string; name: string; phone?: string; onClose: () => void; onDone: () => void }) => {
  const { t } = usePrefs();
  const [n, setN] = useState(name || "");
  const [p, setP] = useState((phone || "").replace(/^\+964/, "0"));
  const [busy, setBusy] = useState(false);
  const submit = async (e: React.FormEvent) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.patch(`/admin/registry/customers/${userId}/details`, { booking_name: n, phone: p });
      toast.success(t("bd.saved"));
      onDone();
    } catch (err) {
      toast.error(errorText(err, t));
    } finally {
      setBusy(false);
    }
  };
  return (
    <Dialog open onOpenChange={(o: boolean) => !o && onClose()}>
      <DialogContent className="rounded-3xl max-w-[calc(100vw-2rem)] sm:max-w-md" data-testid="customer-details-dialog">
        <DialogHeader className="text-start"><DialogTitle className="font-display text-xl inline-flex items-center gap-2"><IdCard className="h-5 w-5" />{t("reg.editDetails")}</DialogTitle></DialogHeader>
        <form onSubmit={submit} className="space-y-3">
          <div className="space-y-1.5">
            <Label htmlFor="cd-name">{t("bd.name")}</Label>
            <Input id="cd-name" required minLength={3} value={n} onChange={(e: any) => setN(e.target.value)} data-testid="customer-details-name" className="h-11 rounded-2xl" />
          </div>
          <div className="space-y-1.5">
            <Label htmlFor="cd-phone">{t("auth.phone")}</Label>
            <Input id="cd-phone" required type="tel" dir="ltr" placeholder="07XX XXX XXXX" value={p} onChange={(e: any) => setP(e.target.value)} data-testid="customer-details-phone" className="h-11 rounded-2xl" />
          </div>
          <button disabled={busy} data-testid="customer-details-save" className="h-11 w-full rounded-full bg-primary text-primary-foreground font-bold disabled:opacity-60">{busy ? t("common.loading") : t("common.save")}</button>
        </form>
      </DialogContent>
    </Dialog>
  );
};
